export const USER_REQUEST = 'users.USER_REQUEST';
export const USER_LOGIN = 'users.USER_LOGIN';
export const USER_UPDATED = 'users.USER_UPDATED';
export const USER_REGISTER = 'users.USER_REGISTER';
export const USER_LOGOUT = 'users.USER_LOGOUT';
export const USER_REMOVED = 'users.USER_REMOVED';
export const AUTH_OPEN_MODAL = 'users.AUTH_OPEN_MODAL';
export const AUTH_CLOSE_MODAL = 'users.AUTH_CLOSE_MODAL';
export const RESET_PASSWORD = 'users.RESET_PASSWORD';
export const FORGOT_PASSWORD = 'users.FORGOT_PASSWORD';
export const SIGN_IN = 'users.SIGN_IN';
export const SIGN_OUT = 'users.SIGN_OUT';
export const USER_GET_PROFILE = 'users.USER_GET_PROFILE';


// WEBPACK FOOTER //
// ./src/types/user.js